import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InstructorState } from '../reducers/instructor.reducer';
import { INSTRUCTOR_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<InstructorState>(INSTRUCTOR_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: InstructorState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: InstructorState) => state.loading);
export const selectSaving = createSelector(selectState, (state: InstructorState) => state.saving);
export const selectSaved = createSelector(selectState, (state: InstructorState) => state.saved);
export const selectError = createSelector(selectState, (state: InstructorState) => state.error);
export const selectInstructor = createSelector(selectState, (state: InstructorState) => state.instructor);
